export default __webpack_public_path__ + "static/colibr-8-a4-e7a529e721ccd91f7ad5489fe0e7e298.pdf";